import { UserQuery } from "@/modules/User/models/UserQuery";
import { FilterOneItem } from "../../GenericSearchBar/model/FilterOneItem";

export const SEARCH_PATIENT_CONSTANTS = {
  HINT: {
    USER: "Seleccione un paciente"
  },

  MESSAGE: {
    ADD_NEW_PATIENT: "Asociar usuario como paciente",
    USER_NO_PATIENT: "El usuario consultado no es paciente"
  },
  FILTER_QUERY_DEFAULT: {
    userState: "Activo",
    externalUser: true
  } as UserQuery,
  DOCUMENT_FILTER_ID: "document"
};

export const FILTER_SEARCH_PATIENT_CONSTANTS: FilterOneItem = {
  labelTitle: " del paciente",
  labelNotFound: "No se encontró paciente para esa busqueda",
  labelAddTitle: "No se encontró paciente con este documento",
  labelAddSubTitle: " Crear nuevo paciente",
  addIcon: "mdi-plus-circle-outline",
  filterIcon: true,
  filters: [
    { name: "Nombre", id: "name" },
    {
      name: "Documento",
      id: "userDocument",
      default: true,
      canAdd: true,
      oneResult: true
    },
    { name: "Correo", id: "userEmail", oneResult: true }
  ]
};
